import {
  FetchNotificationsBegin,
  FetchNotificationsSuccess,
  FetchNotificationsFailure,
  ArchiveNotificationBegin,
  ArchiveNotificationSuccess,
  ArchiveNotificationFailure
} from "./actions"
import configs from "../../configs"

const fetchAllNotifications = token => {
  return fetch(`${configs.api.base}/api/core/notifications/`, {
    method: "GET",
    headers: new Headers({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    })
  })
}

const fetchReadNotifications = token => {
  return fetch(
    `${configs.api.base}/api/core/notifications/?acknowledged=true`,
    {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      })
    }
  )
}

const fetchUnreadNotifications = token => {
  return fetch(
    `${configs.api.base}/api/core/notifications/?acknowledged=false`,
    {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      })
    }
  )
}

export const fetchNotifications = token => {
  return dispatch => {
    dispatch(FetchNotificationsBegin())

    return new Promise((resolve, reject) => {
      Promise.allSettled([
        fetchAllNotifications(token),
        fetchReadNotifications(token),
        fetchUnreadNotifications(token)
      ])
        .then(responses => {
          return Promise.all(
            responses.map(r => {
              if (r.status === "fulfilled" && r.value.status === 200) {
                return r.value.json()
              }
              return {
                results: [],
                count: 0
              }
            })
          )
        })
        .then(([all, read, unread]) => {
          dispatch(
            FetchNotificationsSuccess({
              all,
              read,
              unread
            })
          )
          resolve()
        })
        .catch(() => {
          dispatch(FetchNotificationsFailure())
          reject()
        })
    })
  }
}

export const archiveNotification = (token, listId) => {
  return dispatch => {
    dispatch(ArchiveNotificationBegin())

    const body = {
      notifications: []
    }

    listId.map(id => {
      body.notifications.push({ id })

      return null
    })

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/core/notifications/`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(body)
      })
        .then(response => {
          if (response.status === 200) {
            resolve()
            dispatch(ArchiveNotificationSuccess())
            dispatch(fetchNotifications(token))
          } else {
            reject()
            dispatch(ArchiveNotificationFailure())
          }
        })
        .catch(() => {
          reject()
          dispatch(ArchiveNotificationFailure())
        })
    })
  }
}
